import React from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import CompanyService from "../../../../services/Company/CompanyService";
import AddCompanyModal from "./AddCompanyModal";

const Company = () => {
	const [data, setData] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const companyService = new CompanyService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div></div>
					<div className="add-department">
						{/* {isExist("add_job_title") && ( */}
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => {
								setItem({});
								setAddModal(true);
							}}>
							<i className="la la-plus mx-1"></i>
							{Translate[lang]?.add} {Translate[lang]?.company}
						</Button>
						{/* )} */}
					</div>
				</div>
			</div>

			<Row>
				<Col lg={12}>
					<Card>
						<div
							className={`${hasData === 0 ? "text-center" : "table-style"} `}>
							{loading && (
								<div style={{ height: "400px" }}>
									<Loader />
								</div>
							)}

							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>{Translate[lang]?.legal_name}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.civil_id}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.phone}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.authorised_signatory}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.owner}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.license_number}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.actions}</strong>
											</th>
										</tr>
									</thead>

									<tbody className="table-body">
										{data?.map((item, index) => {
											return (
												<CardItem
													index={index}
													key={index}
													item={item}
													setItem={setItem}
													setAddModal={setAddModal}
													setShouldUpdate={setShouldUpdate}
												/>
											);
										})}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={companyService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={""}
							/>
						</div>
					</Card>
				</Col>
			</Row>

			{addModal && (
				<AddCompanyModal
					item={item}
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
					Service={companyService}
				/>
			)}
		</div>
	);
};

export default Company;
